const ResetIcon = ({ resetAllowed }) => {
  const basePath = `${window.location.origin}/images`;
  return (
    <img
      src={
        resetAllowed
          ? `${basePath}/reset-select.png`
          : `${basePath}/reset-default.png`
      }
      alt="Image Indicator"
      style={{ width: 25, height: 25 , border : '2px solid white', marginBottom: 1.3}}
    />
  );
};

export default ResetIcon;
